export const COOKIE_CONSENT_KEY = "wmt_cookie_consent_v2";
export const COOKIE_CONSENT_EVENT = "wmt:cookie-consent";
export const COOKIE_SETTINGS_EVENT = "wmt:cookie-settings";

export type CookieConsent = "analytics" | "necessary" | null;

export function readCookieConsent(): CookieConsent {
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);
    return value === "analytics" || value === "necessary" ? value : null;
  } catch {
    return null;
  }
}

export function saveCookieConsent(value: Exclude<CookieConsent, null>) {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch {
    /* The choice still applies for the current page. */
  }
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: { value } }));
}

export function clearMetrikaStorage() {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith("_ym") || key.startsWith("ym_")) localStorage.removeItem(key);
    }
  } catch {
    /* ignore unavailable storage */
  }

  const domains = ["", location.hostname, `.${location.hostname.replace(/^www\./, "")}`];
  document.cookie.split(";").forEach((part) => {
    const name = part.split("=")[0]?.trim();
    if (!name || (!name.startsWith("_ym") && !["yandexuid", "yuidss", "ymex", "usst"].includes(name))) return;
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ""}; SameSite=Lax`;
    }
  });
}
